import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import template from './ns-textarea.html';

export class NsTextarea extends PolymerElement {
  static get is () {
    return 'ns-textarea';
  }

  static get template () {
    let htmlElement = document.createElement('TEMPLATE');
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  /**
   * Returns properties of ns-textarea
   */
  static get properties () {
    return {
      /**
      * required
      * Used to indicate that value is required.
      */
      required: {
        type: Boolean,
        value: false
      },
      /**
       * value
       * Passed in as value to ns-input.  Two-way binding utilized.
       */
      value: {
        type: String,
        notify: true
      },
      /**
       * Used to identify if entry is valid
       */
      valid: {
        type: Boolean,
        notify: true
      },
      /**
       * Used to display when field left blank
       */
      requiredMessage: {
        type: String,
        value: 'Required'
      },
      /**
       * Property is used as a flag to track if input element is in focus.
       */
      focused: {
        type: Boolean,
        value: false,
        notify: true,
        reflectToAttribute: true
      },
      maxLength: {
        type: Number,
        value: 250
      }
    };
  }

  connectedCallback () {
    super.connectedCallback();
  }

  validate() {
    this.errorMessage = '';
    this.$.textarea.className = this.$.textarea.className.split(/\s?error/).join('');
    if(this.required && !this.value)
      this.set('errorMessage', this.requiredMessage);

    this.set('valid', !this.errorMessage);
    if(!this.valid)
      this.$.textarea.className += ' error';
  }

  focus() {
    this.focused = true;
    this.$.textarea.className = this.$.textarea.className.split(/\s?error/).join('');
  }

  blur() {
    this.focused = false;
    this.validate();
  }

  keyup(e) {
    this.value = e.target.value;
  }

}

customElements.define(NsTextarea.is, NsTextarea);
